const map = {
	"./flag-au.svg": 11229,
	"./flag-bg.svg": 91766,
	"./flag-cz.svg": 59796,
	"./flag-de.svg": 81322,
	"./flag-gb.svg": 79696,
	"./flag-gr.svg": 28640,
	"./flag-ru.svg": 17844,
	"./flag-us.svg": 84791
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24451;